import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';

const StyledInput = styled.input`
  width: 100%;
  padding: ${props => props.padding || `${theme.spacing.sm} ${theme.spacing.md}`};
  background-color: ${props => props.backgroundColor || theme.colors.background};
  border: ${props => props.border || `1px solid ${theme.colors.border}`};
  border-radius: ${props => props.borderRadius || theme.borderRadius.md};
  color: ${props => props.color || theme.colors.text};
  font-size: ${props => props.fontSize || theme.typography.fontSizes.base};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${props => props.fontWeight || theme.typography.fontWeights.normal};
  outline: none;
  box-sizing: border-box;
  transition: ${theme.transitions.normal};
  
  &::placeholder {
    color: ${theme.colors.textSecondary};
  }
  
  &:focus {
    border-color: ${theme.colors.primaryHover};
    box-shadow: 0 0 0 2px ${theme.colors.primary}20;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Input = ({ 
  children,
  error,
  ...props 
}) => {
  return (
    <StyledInput 
      border={error ? `1px solid ${theme.colors.error}` : undefined}
      {...props}
    >
      {children}
    </StyledInput>
  );
};

export default Input; 